import React, { useState } from "react";
import { ButtonBase } from "@mui/material";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
import { useTranslation } from "../../../hooks/useTranslation";
import { LegalDocumentsDialog } from "./LegalDocumentsDialog";
import { isPublicNext } from "../../../next/public/mode";
import "./styles.scss";

interface Props {
  // "floating": pinned to the bottom-left of the screen (pages without the app sidebar).
  // "sidebar": a quiet row at the bottom of the app's side menu.
  variant: "floating" | "sidebar";
}

/** "Terms & Privacy" — opens the Privacy Policy, Terms of Service and DPA. */
export const LegalDocumentsButton: React.FC<Props> = ({ variant }) => {
  const { p } = useTranslation("legal_docs");
  const [open, setOpen] = useState(false);

  // The new public / registration frame has Terms & Privacy in its own footer (and the new in-app frame in the account menu), so today's
  // floating pill is not rendered at all there: it covered the Continue button at phone width. (The body-class CSS rule is only a second guard,
  // it needs the new frame to have mounted first.) Today's look (no preview, switch on "legacy") is unchanged.
  if (variant === "floating" && isPublicNext()) return null;

  return (
    <>
      <ButtonBase
        className={`legal-docs-button legal-docs-button--${variant}`}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
      >
        <PolicyRoundedIcon aria-hidden className="legal-docs-button__icon" />
        {p("button")}
      </ButtonBase>
      <LegalDocumentsDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
